import { render } from "./SendAlertForm.vue?vue&type=template&id=1d25145a"
import script from "./SendAlertForm.vue?vue&type=script&lang=js"
export * from "./SendAlertForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__